import { render } from "./End2.vue?vue&type=template&id=e5c7b394"
import script from "./End2.vue?vue&type=script&lang=js"
export * from "./End2.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/digiworks/SecoursCatholique/Secours-Catholique_Mots_Vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__